export default __webpack_public_path__ + "static/media/ic_kazakhstan.d8fbfd38.svg";